(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["national-day-promo-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ndp-promo__link--tnc');
    if (trigger) {
      var root = trigger.closest('.ndp-promo');
      var dialog = root && root.querySelector('.ndp-promo__dialog');
      if (dialog) dialog.showModal();
      return;
    }

    var closeBtn = event.target.closest('.ndp-promo__dialog-close');
    if (closeBtn) {
      var dialogToClose = closeBtn.closest('.ndp-promo__dialog');
      if (dialogToClose) dialogToClose.close();
      return;
    }

    if (event.target.classList && event.target.classList.contains('ndp-promo__dialog')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
